import { createContext } from 'react';
import type { AppConfig } from '../../types/app-config-type.ts';
import type { AuthClient } from '../../utils/auth-client.ts';

export type AclContextValue = {
    authClient: AuthClient;
    appConfig: AppConfig;
};

export const AclProviderContext = createContext<AclContextValue | null>(null);
